import { Box, Typography } from "@mui/material";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { useTranslation } from "react-i18next";
import { managersHubMock } from "../mockData";

const GREEN = "#248B70";
const TEXT_MAIN = "rgba(47, 43, 61, 0.9)";
const TEXT_SUB = "rgba(71, 84, 103, 1)";
const CARD = { backgroundColor: "#fff", border: "1px solid rgba(234,234,234,1)", borderRadius: "12px" };

const EarningsSection = () => {
  const { t, i18n } = useTranslation("managers-hub");
  const lang = (i18n.language || "he").toLowerCase().startsWith("he") ? "he" : "en";
  const loc = (v) => (v && typeof v === "object" ? v[lang] ?? v.en : v);
  const m = managersHubMock;
  const e = m.earnings;
  const cur = m.currencySymbol;
  const money = (n) => `${cur}${Number(n).toLocaleString("en-US")}`;

  const Stat = ({ label, value }) => (
    <Box>
      <Typography sx={{ fontSize: "12px", color: TEXT_SUB, mb: "4px" }}>{label}</Typography>
      <Typography sx={{ fontSize: "18px", fontWeight: 700, color: TEXT_MAIN }}>{value}</Typography>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Typography sx={{ fontSize: "18px", fontWeight: 600, color: TEXT_MAIN }}>{t("earnings_title")}</Typography>

      {/* Balance + withdraw + at-a-glance */}
      <Box sx={{ ...CARD, padding: "18px 20px" }}>
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: { xs: "stretch", md: "center" }, justifyContent: "space-between", gap: "16px" }}>
          <Box sx={{ backgroundColor: "rgba(219,240,236,0.5)", borderRadius: "12px", padding: "14px 18px", flex: 1 }}>
            <Typography sx={{ fontSize: "13px", color: TEXT_SUB }}>{t("current_balance")}</Typography>
            <Typography sx={{ fontSize: "26px", fontWeight: 700, color: GREEN }}>{money(e.currentBalance)}</Typography>
            {/* Paid out automatically at month-end — no manual withdraw. */}
            <Typography sx={{ fontSize: "12px", color: TEXT_SUB, mt: "2px" }}>{t("next_payout", { date: loc(e.nextPayout) })}</Typography>
          </Box>

          <Box sx={{ display: "flex", gap: "32px", paddingInline: { md: "8px" } }}>
            <Stat label={t("earn_all_time")} value={money(e.allTime)} />
            <Stat label={t("earn_this_month")} value={money(e.thisMonth)} />
          </Box>
        </Box>
      </Box>

      {/* Payout history */}
      <Box sx={{ ...CARD, overflow: "hidden" }}>
        <Box sx={{ padding: "14px 18px", borderBottom: "1px solid rgba(234,234,234,1)" }}>
          <Typography sx={{ fontSize: "15px", fontWeight: 600, color: TEXT_MAIN }}>{t("payout_history_title")}</Typography>
        </Box>
        {e.payouts.map((p, i) => (
          <Box key={i} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", padding: "12px 18px", borderBottom: i < e.payouts.length - 1 ? "1px solid rgba(240,240,240,1)" : "none", flexWrap: "wrap" }}>
            <Box sx={{ minWidth: "120px" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 500, color: TEXT_MAIN }}>{loc(p.period)}</Typography>
              {p.date && <Typography sx={{ fontSize: "12px", color: TEXT_SUB }}>{t("paid_on", { date: loc(p.date) })}</Typography>}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Box sx={{ fontSize: "12px", fontWeight: 600, borderRadius: "6px", padding: "3px 10px", backgroundColor: p.status === "paid" ? "rgba(36,139,112,0.12)" : "rgba(255,151,51,0.16)", color: p.status === "paid" ? GREEN : "#E08A00" }}>
                {t(`payout_status_${p.status}`)}
              </Box>
              <Typography sx={{ fontSize: "15px", fontWeight: 600, color: TEXT_MAIN, minWidth: "80px", textAlign: "end" }}>{money(p.amount)}</Typography>
              <Typography component="button" type="button" sx={{ border: "none", background: "none", fontFamily: "inherit", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", fontSize: "13px", color: TEXT_SUB, "&:hover": { color: GREEN } }}>
                <ReceiptLongOutlinedIcon sx={{ fontSize: 16 }} />
                {t("payout_statement")}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default EarningsSection;
